import { connectResources } from '@ds-frontend/resource'

import ProductReviewsView from './ProductReviewsView'


export default connectResources({
  endpoint: 'api/v1/feefo/product-reviews',
  namespace: 'productReviews',
  reducer: 'paginationList',
  queries: ['kind', 'parent_id', 'offset', 'limit'],
}, { prefetch: false },
)(ProductReviewsView)
